/**
 * Reports slice — chỉ giữ phần cần cho Báo cáo V2:
 *   - Lịch sử xuất file (`history`) kèm `ReportExportOptions` + snapshot filter.
 *   - Format xuất mặc định toàn app.
 */

import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { ReportExportFormat, ReportHistoryItem } from '../types/report.types';

export interface ReportsState {
  exportFormat: ReportExportFormat;
  isExporting: boolean;
  history: ReportHistoryItem[];
}

const initialState: ReportsState = {
  exportFormat: 'pdf',
  isExporting: false,
  history: [],
};

const MAX_HISTORY = 50;

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setExportFormat(state, action: PayloadAction<ReportExportFormat>) {
      state.exportFormat = action.payload;
    },
    setIsExporting(state, action: PayloadAction<boolean>) {
      state.isExporting = action.payload;
    },
    addHistoryItem(state, action: PayloadAction<ReportHistoryItem>) {
      state.history.unshift(action.payload);
      if (state.history.length > MAX_HISTORY) {
        state.history = state.history.slice(0, MAX_HISTORY);
      }
    },
    removeHistoryItem(state, action: PayloadAction<string>) {
      state.history = state.history.filter((item) => item.id !== action.payload);
    },
    clearHistory(state) {
      state.history = [];
    },
  },
});

export const {
  setExportFormat,
  setIsExporting,
  addHistoryItem,
  removeHistoryItem,
  clearHistory,
} = reportsSlice.actions;

export default reportsSlice.reducer;

export const selectExportFormat = (state: { reports: ReportsState }) => state.reports.exportFormat;
export const selectIsExporting = (state: { reports: ReportsState }) => state.reports.isExporting;
export const selectReportHistory = (state: { reports: ReportsState }) => state.reports.history;
